import React from 'react';
import {Show, TabbedShowLayout, useRecordContext} from 'react-admin';

import { ActionsWithBackButton } from '../../../components/actionbars/ActionsWithBackButton';
import {AppRoles} from '../../../entities/UserRole';
import { isInArray } from '../../../utils/general';
import { ChatTab, GeneralTab, HistoryTab } from './Tabs';

export const tabbedShowLayoutPadding = 8;

export const DeviationShow = (props) => {
	const isDeviationHistoryTab = props.permissions && isInArray(AppRoles, props.permissions.role);

	return (
		<Show actions={<ActionsWithBackButton />} {...props} >
			<TabbedShowLayout style={{paddingBottom: tabbedShowLayoutPadding}} {...props}>
				<GeneralTab permissions={props.permissions} label="tab.geneneral.name"/>
				{isDeviationHistoryTab && <HistoryTab permissions={props.permissions} label="tab.deviations_history.name"/>}
				<ChatTab label="tab.chat.name" path="chat"/>
			</TabbedShowLayout>
		</Show>
	);
}
